import { useMemo } from 'react';

export type ReactionType = 'heart' | 'star' | 'like';

interface Props {
  type: ReactionType;
  className?: string;
  style?: React.CSSProperties;
}

const HEART_PATH =
  'M50 90 C26 70 6 52 6 32 C6 16 17 6 30 6 C41 6 48 13 50 22 C52 13 59 6 70 6 C83 6 94 16 94 32 C94 52 74 70 50 90 Z';

// classic 5-point star, outer radius 48 / inner radius 19.5, pointing up
const STAR_PATH =
  'M50 2 L61.5 34.2 L95.7 35.2 L68.5 56 L78.2 88.8 L50 69.5 L21.8 88.8 L31.5 56 L4.3 35.2 L38.5 34.2 Z';

const HEART_VARIANTS = [
  { id: 'karaokr-grad-heart-red', from: '#ff6473', to: '#f0134d' },
  { id: 'karaokr-grad-heart-indigo', from: '#8b8bf5', to: '#2a2a7a' },
];

function HeartIcon() {
  // Each heart randomly picks one of the color variants so the room can compare.
  const variant = useMemo(() => HEART_VARIANTS[Math.floor(Math.random() * HEART_VARIANTS.length)], []);
  return (
    <>
      <defs>
        <linearGradient id={variant.id} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={variant.from} />
          <stop offset="100%" stopColor={variant.to} />
        </linearGradient>
      </defs>
      <path d={HEART_PATH} fill={`url(#${variant.id})`} />
    </>
  );
}

function StarIcon() {
  return (
    <>
      <defs>
        <linearGradient id="karaokr-grad-star" x1="20%" y1="0%" x2="80%" y2="100%">
          <stop offset="0%" stopColor="#ffe9a3" />
          <stop offset="50%" stopColor="#ffc93c" />
          <stop offset="100%" stopColor="#f08c00" />
        </linearGradient>
      </defs>
      {/* O stroke com linejoin round "incha" a estrela clássica para o estilo
         puffy da estrela do Mario (pontas e vales arredondados). */}
      <path
        d={STAR_PATH}
        fill="url(#karaokr-grad-star)"
        stroke="url(#karaokr-grad-star)"
        strokeWidth={9}
        strokeLinejoin="round"
      />
      <ellipse cx="40" cy="30" rx="12" ry="7" fill="#ffffff" opacity="0.5" transform="rotate(-25 40 30)" />
    </>
  );
}

export default function ReactionIcon({ type, className = '', style }: Props) {
  if (type === 'like') {
    return (
      <span className={className} style={{ fontSize: '1em', lineHeight: 1, ...style }} aria-hidden="true">
        👍
      </span>
    );
  }
  return (
    <svg
      viewBox="0 0 100 100"
      className={className}
      style={{ width: '1em', height: '1em', display: 'inline-block', verticalAlign: 'middle', ...style }}
      aria-hidden="true"
    >
      {type === 'heart' && <HeartIcon />}
      {type === 'star' && <StarIcon />}
    </svg>
  );
}
